export const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const DEFAULT_IMAGE = 'https://dyn48y1sx7ytn.cloudfront.net/images/default.png';
export const TRANSFORM_CDN_DOMAIN = 'dyn48y1sx7ytn.cloudfront.net';
export const GLOBAL_MAX_FILES_PER_UPLOAD = 200;
